// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"436":"5d1699c5","449":"54524e02","541":"388de703","706":"8722f7db","925":"ae2e0ce5","940":"dcc5a495"}[chunkId] + ".css";
};